import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";

import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Stack,TextField } from "@mui/material";
import CustomButton from "../../../components/CustomButton";

import DeleteIcon from "@mui/icons-material/Delete";

import Loader from "../../../components/Loader";

import { formatPricing } from "../../../utils/helper.utils";
import {
  deletePlanById,
  updateBillboardDurationAPI,
} from "../../../apis/plans.apis";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function PlanList({ open, onClose, data, disableDelete }) {
  const [isLoading, setisLoading] = useState(false);
  const [editedDurations, setEditedDurations] = useState({});
  const [localData, setLocalData] = useState([]);

  useEffect(() => {
    setLocalData(data?.map((row) => ({ ...row })) || []);
  }, [data]);

  const handleDurationChange = (plan_id, value) => {
    setLocalData((prev) =>
      prev.map((row) =>
        row.plan_id === plan_id ? { ...row, duration: value } : row
      )
    );

    const billboardRow = localData.find((row) => row.plan_id === plan_id);
    if (billboardRow) {
      setEditedDurations((prev) => ({
        ...prev,
        [billboardRow.id]: value, // Use billboard ID
      }));
    }
  };

  const handleSaveAllDurations = async () => {
    const updates = Object.entries(editedDurations); // [ [billboard_id, newDuration], ... ]
    if (updates.length === 0) {
      toast.info("No duration changes to save.");
      return;
    }

    setisLoading(true);
    try {
      await Promise.all(
        updates.map(([billboardId, duration]) =>
          updateBillboardDurationAPI(billboardId, Number(duration))
        )
      );
      toast.success("All durations updated!");
      setEditedDurations({});
    } catch (error) {
      toast.error("Failed to update some durations.");
    } finally {
      setisLoading(false);
    }
  };

  const handleClose = () => {
    onClose?.();
  };

  const handleDeletePlan = (plan_id) => {
    if (!window.confirm("Are you sure you want to delete?")) {
      return;
    }

    setisLoading(true);

    deletePlanById(plan_id)
      .then((v) => {
        toast.success("Plan deleted!");
        handleClose();
      })
      .catch((e) => {
        toast.error("Failed to delete the plan!");
      })
      .finally((e) => {
        setisLoading(false);
      });
  };

  const handleSaveDuration = async (id) => {
    const item = localData.find((row) => row.id === id);
    if (!item || isNaN(item.duration)) return;

    try {
      setisLoading(true);
      await updateBillboardDurationAPI(id, Number(item.duration));
      toast.success("Duration updated!");
    } catch {
      toast.error("Failed to update duration");
    } finally {
      setisLoading(false);
    }
  };
 console.log("localData", localData)
  return (
    <React.Fragment>
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              Plan List
            </Typography>
          </Toolbar>
        </AppBar>
        <div style={{ padding: "16px" }}>
          <CustomButton
            variant="contained"
            color="primary"
            onClick={handleSaveAllDurations}
            disabled={isLoading || Object.keys(editedDurations).length === 0}
          >
            Save All Durations
          </CustomButton>

        </div>
        <TableContainer sx={{ mt: 2 }} component={Paper}>
          <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
            <TableHead>
              <TableRow>
                <TableCell>Location</TableCell>
                <TableCell align="right">Illumination</TableCell>
                <TableCell align="right">Media Type</TableCell>
                <TableCell align="right">Width</TableCell>
                <TableCell align="right">Height</TableCell>
                <TableCell align="right">Qty</TableCell>

                <TableCell align="right">Size</TableCell>
                <TableCell align="right">Duration</TableCell>
                <TableCell align="right">Impression Per Duration (per thousand)</TableCell>
                <TableCell align="right">CPM</TableCell>
                <TableCell align="right">Rental Per Month</TableCell>
                <TableCell align="right">Cost For Duration</TableCell>
                <TableCell align="right">Printing</TableCell>
                <TableCell align="right">Mounting</TableCell>
                <TableCell align="right">Total</TableCell>
                <TableCell align="right">Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {localData?.map((row) => (
                <TableRow
                  key={row.plan_id}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    {row.location}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {row.illumination}
                  </TableCell>
                  <TableCell align="right">{row.media_type}</TableCell>
                  <TableCell align="right">{row.width}</TableCell>
                  <TableCell align="right">{row.height}</TableCell>
                  <TableCell align="right">{row.quantity}</TableCell>
                  
                  <TableCell align="right">{row.area}</TableCell>
                  <TableCell align="right">
                    <Stack
                      direction="row"
                      spacing={1}
                      alignItems="center"
                      justifyContent="flex-end"
                    >
                      <TextField
                        variant="outlined"
                        size="small"
                        type="number"
                        placeholder="Duration"
                        value={Number(row.duration)}
                        onChange={(e) =>
                          handleDurationChange(row.plan_id, e.target.value)
                        }
                        disabled={isLoading}
                        sx={{ width: 80 }}
                      />
                      
                    </Stack>
                  </TableCell>
                  <TableCell align="right">{((row.avg_calculated_impression * 24 * row.duration)/1000).toFixed(2)}K</TableCell>
                  <TableCell align="right">{(
                    ((parseFloat(row.printing_cost || 0) +
                      parseFloat(row.mounting_cost || 0) +
                      (parseFloat(row.rental_per_month || 0) * parseFloat(row.duration || 0)) / 30) * 1000) /
                    (row.avg_calculated_impression * 24 * row.duration)
                  ).toFixed(2)}</TableCell>
                  <TableCell align="right">
                    {formatPricing(row.rental_per_month)}
                  </TableCell>
                  <TableCell align="right">
                    {formatPricing(
                      (parseFloat(row.rental_per_month || 0) *
                        parseFloat(
                          editedDurations[row.plan_id] ?? row.duration
                        )) /
                        30
                    )}
                  </TableCell>
                  <TableCell align="right">
                    {formatPricing(row.printing_cost)}
                  </TableCell>
                  <TableCell align="right">
                    {formatPricing(row.mounting_cost)}
                  </TableCell>
                  <TableCell align="right">
                    {formatPricing(
                      parseFloat(row.printing_cost || 0) +
                        parseFloat(row.mounting_cost || 0) +
                        (parseFloat(row.rental_per_month || 0) *
                          parseFloat(
                            editedDurations[row.plan_id] ?? row.duration
                          )) /
                          30
                    )}
                  </TableCell>
                  <TableCell align="right">
                    <IconButton
                      size="small"
                      onClick={handleDeletePlan.bind(this, row.plan_id)}
                      sx={{ backgroundColor: "red", borderRadius: "6px" }}
                      disabled={disableDelete}
                    >
                      <DeleteIcon fontSize="12" sx={{ color: "white" }} />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <Loader open={isLoading} />
      </Dialog>
    </React.Fragment>
  );
}
